/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./TheChangelog.vue?vue&type=template&id=2e4be408&scoped=true"
import script from "./TheChangelog.ts?vue&type=script&lang=ts&external"
export * from "./TheChangelog.ts?vue&type=script&lang=ts&external"
import style0 from "./TheChangelog.vue?vue&type=style&index=0&id=2e4be408&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4be408",
  null
  
)

export default component.exports